import React from 'react';
import CustomNumber from './CustomNumber';

const PercentageNumber = (props) => <CustomNumber {...props} suffix="%" />;

export default PercentageNumber;



// WEBPACK FOOTER //
// ./src/core/formatting/PercentageNumber.jsx